export const useScheduleOfSupport = () => {
  return {
    rows: [{ label: 'Schedule of support', rows: [{ label: 'Schedule of support' }] }],
  };
};
